import React, { useState } from "react";
import PropTypes from "prop-types";
import { FormGroup, Input, Label, Button, ModalFooter, Spinner } from "reactstrap";

const propTypes = {
  feedbackOptions: PropTypes.arrayOf(
    PropTypes.shape({
      value: PropTypes.string.isRequired,
      label: PropTypes.string.isRequired
    })
  ).isRequired,
  isLoading: PropTypes.bool.isRequired,
  error: PropTypes.string,
  onSubmit: PropTypes.func.isRequired,
  onKeep: PropTypes.func.isRequired
};

const CancelFeedbackStep = ({ feedbackOptions, isLoading, error = null, onSubmit, onKeep }) => {
  const [selected, setSelected] = useState("");
  const [otherText, setOtherText] = useState("");

  const handleSubmit = () => {
    if (!selected) return;
    onSubmit({ feedbackOption: selected, otherText: selected === "other" ? otherText : undefined });
  };

  return (
    <div>
      <p className="text-center text-muted mb-3">
        Please let us know why you would like to cancel:
      </p>

      {error && (
        <div className="notifications danger mb-3">
          <div className="notifications__error-message">{error}</div>
        </div>
      )}

      <FormGroup>
        {Object.entries(feedbackOptions).map(([value, label]) => (
          <div key={value} className="mb-2 ml-4">
            <Label check className="d-flex align-items-start">
              <Input
                type="radio"
                name="cancel_feedback"
                value={value}
                checked={selected === value}
                onChange={() => setSelected(value)}
                className="mt-1 mr-2"
              />
              <span>{label}</span>
            </Label>
            {value === "other" && selected === "other" && (
              <Input
                type="text"
                className="mt-1 ml-4"
                placeholder="Please describe..."
                value={otherText}
                onChange={e => setOtherText(e.target.value)}
              />
            )}
          </div>
        ))}
      </FormGroup>

      <ModalFooter className="pt-2 px-0">
        <Button color="secondary" className="btn-sharp" onClick={onKeep}>
          Back to my ad
        </Button>
        <Button
          color="primary"
          className="btn-sharp"
          onClick={handleSubmit}
          disabled={!selected || isLoading}
        >
          {isLoading ? (
            <>
              <Spinner color="light" size="sm" /> Submitting...
            </>
          ) : (
            "Submit"
          )}
        </Button>
      </ModalFooter>
    </div>
  );
};

CancelFeedbackStep.propTypes = propTypes;

export default CancelFeedbackStep;
